<template>
  <div>
    <!-- PC, タブレット -->
    <div class="pc-block">
      <div :class="{'planSelectPrepareBoxes': isFlex}">
        <!-- プラン1 -->
        <div :class="{'planSelectPrepareBox': isFlex, 'plan-left': isFlex}">
          <p v-show="!canSelectPersonalPlan && showPersonalPlan" class="planSelectPrepareBoxText">準備中</p>
        </div>
        <!-- プラン2 -->
        <div :class="{'planSelectPrepareBox': isFlex}">
          <p v-show="!canSelectCorporatePlan && showCorporatePlan" class="planSelectPrepareBoxText">準備中</p>
        </div>
      </div>

      <!-- プラン説明部分 -->
      <div :class="{'planSelectPrepareBoxes': isFlex}">
        <!-- プラン1 -->
        <div :class="{'planSelectDescBox': true, 'is-flex': isFlex, ' plan-left': isFlex, 'disable':this.disablePersonalPlan, 'is-hidden': !showPersonalPlan, 'personalBox': true}" @click="selectPersonalPlan()">
          <div>
            <div v-if="hasTrial" class="trialBox">
              <h4 :class="{'planSelectDescBoxTitle':true}">{{ trialDate }}日間の無料トライアル</h4>
              <p class="trial-limit">(本日から{{ trialEndAt }}まで)</p>
            </div>
            <img :class="{'planSelectImageBoxImg':true}" :src="personalPlanImagePath" v-if="hasPersonalPlanImage">
            <h4 :class="{'planSelectDescBoxTitle':true, 'disable':this.disablePersonalPlan}">{{ personalPlanTitle }}</h4>
          </div>
          <div class="tiny_textbox" v-if="personalPlanBody" v-html="personalPlanBody"></div>
        </div>

        <!-- プラン2 -->
        <div :class="{'planSelectDescBox': true, 'is-flex': isFlex, 'disable':this.disableCorporatePlan, 'is-hidden': !showCorporatePlan, 'corpolateBox': true}" @click="selectCorporatePlan()">
          <div :class="{'mt60':hasTrial}">
            <img :class="{'planSelectImageBoxImg':true}" :src="corporatePlanImagePath" v-if="hasCorporatePlanImage">
            <h4 :class="{'planSelectDescBoxTitle':true, 'disable':this.disableCorporatePlan, corpolateTitle:true}">{{ corporatePlanTitle }}</h4>
          </div>
          <div class="tiny_textbox" v-if="corporatePlanBody" v-html="corporatePlanBody"></div>
        </div>
      </div>
    </div>

    <!-- スマホ -->
    <div class="sp-block">
      <div class="mb20">
        <!-- プラン1 -->
        <div @click="selectPersonalPlan()" :class="{'planSelectFormItems': true}" v-show="showPersonalPlan">
          <div v-if="hasTrial">
            <h4 :class="{'planSelectDescBoxTitle':true}">{{ trialDate }}日間の無料トライアル</h4>
            <p class="trial-limit">(本日から{{ trialEndAt }}まで)</p>
          </div>
          <img class="planSelectImageBoxImg" :src="personalPlanImagePath" v-if="hasPersonalPlanImage">
          <h4 class="planSelectDescBoxTitle">{{ personalPlanTitle }}</h4>
          <span v-show="!canSelectPersonalPlan" class="planSelectFormItemsPrepare">準備中</span>
          <div class="tiny_textbox mt20" v-if="personalPlanBody" v-html="personalPlanBody"></div>
        </div>

        <!-- プラン2 -->
        <div @click="selectCorporatePlan()" :class="{'planSelectFormItems': true, corpolateBox:true}" v-show="showCorporatePlan">
          <img class="planSelectImageBoxImg" :src="corporatePlanImagePath" v-if="hasCorporatePlanImage">
          <h4 class="planSelectDescBoxTitle corpolateTitle">{{ corporatePlanTitle }}</h4>
          <span v-show="!canSelectCorporatePlan" class="planSelectFormItemsPrepare">準備中</span>
          <div class="tiny_textbox mt20" v-if="corporatePlanBody" v-html="corporatePlanBody"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    props: [
      'plan',
      'showPersonalPlan',
      'showCorporatePlan',
      'canSelectPersonalPlan',
      'canSelectCorporatePlan',
      'hasPersonalPlanImage',
      'hasCorporatePlanImage',
      'personalPlanImagePath',
      'corporatePlanImagePath',
      'hasTrial',
      'trialDate',
      'trialEndAt',
      'loggedIn'
    ],

    data () {
      return {
        objPlan: JSON.parse(this.plan),
        personalPlanTitle: '',
        personalPlanBody: '',
        corporatePlanTitle: '',
        corporatePlanBody: '',
        disablePersonalPlan: !this.canSelectPersonalPlan,
        disableCorporatePlan: !this.canSelectCorporatePlan,
        isFlex: this.showPersonalPlan && this.showCorporatePlan,
      }
    },

    methods: {
      selectPersonalPlan () {
        if (!this.canSelectPersonalPlan) {
          return false
        }

        if (this.loggedIn) {
          window.location.href = '/register/personal_plan'
          return false
        }

        axios.get('/set-after-login', {
          params: {
            url: '/register/personal_plan'
          }
        }).then(res => {
          window.location.href = '/register'
        }).catch(error => {
          console.log(error)
        })
      },

      selectCorporatePlan () {
        if (!this.canSelectCorporatePlan) {
          return false
        }

        window.location.href = '/register/corpolate_plan_select'
      }
    },

    mounted () {
      this.personalPlanTitle = this.objPlan.personal_plan_title
      this.personalPlanBody = this.objPlan.personal_plan_body
      this.corporatePlanTitle = this.objPlan.corporate_plan_title
      this.corporatePlanBody = this.objPlan.corporate_plan_body
    }
  }
</script>

<style lang="scss" scoped>
  .is-hidden {display:none;}
  .disable {color:white !important;background-color:#CCCCCC !important;cursor:inherit;}
  .trial-limit {text-align:center;font-size:14px;}
  .trialBox {height: 60px;}
  .personalBox{border: 1px solid #0042bd;}
  .corpolateBox{border:1px solid #30876e;}
  .corpolateTitle{color:#30876e;}
</style>